module.exports = __webpack_public_path__ + "components/country-flag/static/li-f6fcf74592064fbc5cdf4f6f8c3f02d3.svg";